import { Model } from '../parents/model';

export class EnumeratorModel extends Model {
  // PAYMENT METHODS
  static ATTR_PAYMENT_SERVICE = 'payment_service';

  // ORDERS
  static ATTR_THIRD_PARTY_SERVICE = 'third_party_service';

  // ORDER FILES
  static ATTR_ORDER_FILE_TYPE = 'order_file_type';

  // ORDER CREDIT STATES
  static ATTR_ORDER_CREDIT_STATE = 'order_credit_state';

  // PAYMENT METHODS
  get paymentService() {
    return this.attributes[EnumeratorModel.ATTR_PAYMENT_SERVICE];
  }

  // ORDERS
  get thirdPartyService() {
    return this.attributes[EnumeratorModel.ATTR_THIRD_PARTY_SERVICE];
  }

  // ORDER CREDIT STATES
  get orderCreditState() {
    return this.attributes[EnumeratorModel.ATTR_ORDER_CREDIT_STATE];
  }

  /**
   * Get the enum list transformed to an array of objects for use in a select component.
   * @param {ATTR_PAYMENT_SERVICE | ATTR_THIRD_PARTY_SERVICE | ATTR_ORDER_FILE_TYPE | ATTR_ORDER_CREDIT_STATE} enumKey
   * @returns {{text: string, value: number}[]}
   */
  getEnumForSelect(enumKey) {
    const enumList = this.attributes[enumKey];
    return Object.keys(enumList).map(key => ({
      text: enumList[key],
      value: Number(key),
    }));
  }

  /**
   * @param {Model} model
   */
  update(model) {
    Object.keys(model.attributes).forEach(attribute => {
      if (!this.attributes[attribute]) {
        this.attributes[attribute] = model.attributes[attribute];
      }
    });
  }
}
